export default __webpack_public_path__ + "static/media/ImagenDashboard.ca6765b2.svg";